import { Controller } from "@hotwired/stimulus"

// Toggles visibility of the advanced filters panel (status, categories, suppliers).
// When open, the toggle button gets an active state for visual feedback.
export default class extends Controller {
  static targets = ["panel", "toggleButton"]

  connect() {
    this.syncToggleState()
  }

  toggle() {
    this.panelTarget.classList.toggle("hidden")
    this.syncToggleState()
  }

  syncToggleState() {
    if (!this.hasToggleButtonTarget) return
    const isOpen = !this.panelTarget.classList.contains("hidden")
    this.toggleButtonTarget.setAttribute("aria-expanded", isOpen)
    this.toggleButtonTarget.classList.toggle("bg-slate-100", isOpen)
    this.toggleButtonTarget.classList.toggle("ring-1", isOpen)
    this.toggleButtonTarget.classList.toggle("ring-slate-200", isOpen)
  }
}
